/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoldersIcon20Solid = forwardRef('FoldersIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 3A1.5 1.5 0 0 0 1 4.5V14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H9.415a.75.75 0 0 1-.603-.304l-.807-1.089A1.5 1.5 0 0 0 6.8 3H2.5Zm.75 5.75A.75.75 0 0 1 4 8h10a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M19.75 8.75a.75.75 0 0 0-1.5 0v5.75a3.75 3.75 0 0 1-3.75 3.75H5.75a.75.75 0 0 0 0 1.5h8.75c2.9 0 5.25-2.35 5.25-5.25V8.75Z" })));
});
